import { IAccMonKhongTinhHocPhiActionTypes } from "../../action-types/category/IMonKhongTinhHocPhiActions";
import { IMonKhongTinhHocPhiReducer } from "../../reducer-model/category/IMonKhongTinhHocPhiReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IMonKhongTinhHocPhiReducer = {
  status: eReducerStatusBase.is_not_initialization,
  monKhongTinhHocPhis: [],
};
export const monKhongTinhHocPhiReducer = (
  state: IMonKhongTinhHocPhiReducer = iniState,
  action: IAccMonKhongTinhHocPhiActionTypes,
): IMonKhongTinhHocPhiReducer => {
  switch (action.type) {
    case "MON_KHONG_TINH_HOC_PHI_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "MON_KHONG_TINH_HOC_PHI_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        monKhongTinhHocPhis: action.payload,
      };
    case "MON_KHONG_TINH_HOC_PHI_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MON_KHONG_TINH_HOC_PHI_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "MON_KHONG_TINH_HOC_PHI_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "MON_KHONG_TINH_HOC_PHI_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MON_KHONG_TINH_HOC_PHI_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "MON_KHONG_TINH_HOC_PHI_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "MON_KHONG_TINH_HOC_PHI_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MON_KHONG_TINH_HOC_PHI_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        monKhongTinhHocPhiEditing: action.payload,
      };
    case "MON_KHONG_TINH_HOC_PHI_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
        monKhongTinhHocPhiEditing: undefined,
      };
    default:
      return state;
  }
};
